import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import { byId } from 'store/utils/sortFunctions';
import KeyResult from 'models/GrowthPlan/KeyResult';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.KEY_RESULTS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results
              .reduce(
                (keyResultsById, keyResult) =>
                  keyResultsById.set(String(keyResult.id), new KeyResult(keyResult)),
                state.get('data').get('byId')
              )
              .sort(byId),
          },
        })
      );
    case types.KEY_RESULT_FETCH_SUCCEEDED:
    case types.KEY_RESULT_CREATE_SUCCEEDED:
    case types.KEY_RESULT_UPDATE_SUCCEEDED: {
      return (() =>
        state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new KeyResult(action.payload)),
            },
          })
        ))();
    }
    case types.KEY_RESULT_FETCH:
    case types.KEY_RESULT_CREATE:
    case types.KEY_RESULT_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.KEY_RESULT_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
          },
        })
      );
    case types.KEY_RESULT_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.KEY_RESULT_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.KEY_RESULT_FETCH_FAILED:
    case types.KEY_RESULTS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
